export default function toggleGenderSelfDescribed(el: HTMLElement) {
  const genderInput = el.querySelector<HTMLInputElement>('[name="subscription[gender]"]')!;
  const genderSelfDescribedInput = el.querySelector<HTMLInputElement>(
    '[name="subscription[gender_self_described]"]'
  )!;
  const genderSelfDescribedField = el.querySelector<HTMLElement>("#gender_self_described")!;
  const genderSelfDescribedInitialValue = genderSelfDescribedInput.value;

  function updateGender() {
    if (genderInput.value === "W") {
      genderSelfDescribedField.classList.remove("form-card__field--readonly")
      genderSelfDescribedInput.readOnly = false;
      genderSelfDescribedInput.value = genderSelfDescribedInitialValue;
    } else {
      genderSelfDescribedField.classList.add("form-card__field--readonly");
      genderSelfDescribedInput.readOnly = true;
      genderSelfDescribedInput.value = "";
    }
  }

  genderInput.addEventListener("change", updateGender);
  updateGender();
}
